export const stripOutDigits = (input) => {
  const re = /[^0-9]/g;
  const newString = input.replace(re, "");

  return newString;
};
